module.exports = __webpack_public_path__ + "img/bg-congrats-2.b4af5e5d.svg";